import { render, staticRenderFns } from "./tagger.vue?vue&type=template&id=1a0aa936&scoped=true"
import script from "./tagger.vue?vue&type=script&lang=js"
export * from "./tagger.vue?vue&type=script&lang=js"
import style0 from "./tagger.vue?vue&type=style&index=0&id=1a0aa936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0aa936",
  null
  
)

export default component.exports